//
// AxisTickValueFormatOptions.js
// gtl
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "../core/GTLModel";

var AxisTickValueFormatOptions = createModule("gtl::AxisTickValueFormatOptions", ["commons::PropertyOwner","commons::BaseModel","gtl::GTLModel"], EventDispatcher, [
    ,
    {
        maxDecimals: 4,
        format: 7,
        useDataFormat: 2,
        preferredDecimals: 4,
        extractScale: 2,
        maxWidth: 4,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default AxisTickValueFormatOptions;
